































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {getAllModuleBrokerEventTypes} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import Loading from '@c/controls/Loading.vue';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {connectionPModuleBokerEvents} from '@/api/configApi';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {
  pmoduleDataRoutesByTypeMap,
  pmoduleStoresByTypeMap,
} from '@/views/system/modules/configurate';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import {PModuleType} from '@/enums/configs';

@Component({
  components: {
    Loading,
    SelectionList,
  },
})
export default class BrokerLogs extends Vue {
  @Prop()
  selectedPModuleIds!: string[];

  // Источник данных для модуля
  @Prop() apiStore!: any;

  // Какие события показываем в фильтре: все или события модуля, если компонента на странице модуля
  @Prop({default: false})
  onlyPModuleEventTypes!: boolean;

  // Список типов событий
  eventTypes: {name: string; id: number}[] = [];

  // Список выбранных идентификаторов типов событий
  selectedEventTypesIds: number[] = [];

  // Выбранный размер лога
  selectedSize = {value: 10, text: '10'};

  // Показатель заморозки лога
  freeze = false;

  // Список размеров лога
  sizes = [
    {value: 10, text: '10'},
    {value: 20, text: '20'},
    {value: 50, text: '50'},
    {value: 100, text: '100'},
  ];

  // Веб сокет лога
  socket!: WebSocket | null;

  // Лог и отображаемый лог
  logs: {
    collapsed: boolean;
    eventType: string;
    sender: string;
    data: any;
    timestamp: number;
  }[] = [];
  viewLogs: {
    collapsed: boolean;
    eventType: string;
    sender: string;
    data: any;
    timestamp: number;
  }[] = [];

  // Получить размер лога в px
  get logSizePx() {
    return this.selectedSize.value * 24;
  }

  sliceDataArrayLength = 10;

  // Загрузка типов событий
  eventTypesLoading = true;
  eventTypesError = false;
  async loadEventTypes() {
    try {
      this.eventTypesLoading = true;
      this.eventTypesError = false;

      const eventTypes = this.onlyPModuleEventTypes
        ? await this.apiStore.getEventTypes()
        : await getAllModuleBrokerEventTypes(); //TODO: refactor, use store
      this.eventTypes = eventTypes.map((x: any, i: any) => ({id: i + 1, name: x.type}));
      this.selectedEventTypesIds = this.eventTypes.map((x: any) => x.id);
    } catch {
      this.eventTypesError = true;
    } finally {
      this.eventTypesLoading = false;
    }
  }

  @Watch('selectedPModuleIds')
  onSelectedModules() {
    if (this.selectedEventTypesIds.length) {
      this.closeWS();
      this.openWS();
    }
  }

  @Watch('selectedEventTypesIds')
  onSelectedEventTypes() {
    if (this.selectedPModuleIds.length) {
      this.closeWS();
      this.openWS();
    }
  }

  @Watch('selectedSize')
  onSelectedSize(size: any) {
    const logs = [...this.logs];
    if (logs.length > size.value) {
      logs.splice(0, logs.length - size.value);
    }
    this.logs = logs;
    this.viewLogs = [...this.logs];
  }

  async created() {
    await this.loadEventTypes();
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Показать подробно элемент лога
  show(item: any) {
    item.collapsed = false;
  }

  // Скрыть подробности элемента лога
  hide(item: any) {
    item.collapsed = true;
  }

  // Показать все данные
  async showData(item: any) {
    await pmoduleModule.fetchAll();
    const fmodule = pmoduleModule.all.filter(x => x.guid == item.sender);
    if (!fmodule.length) return;
    const pmodule = fmodule[0];

    if (!pmodule.id) return;

    const pmoduleStore = this.getModuleStore(pmodule.type);

    if (!pmoduleStore) return;

    const data = await pmoduleStore.getEventData({
      id: pmodule.id,
      eventType: item.eventType,
      timestamp: item.timestamp,
    });
    if (data)
      window
        .open('')
        ?.document.write(
          '<html><body><pre>' + JSON.stringify(data, null, 2) + '</pre></body></html>',
        );
  }

  // Открыть в новом окне страницу ПМ
  async go(item: any) {
    //грузим тип модуля по guid
    await pmoduleModule.fetchAll();
    const fmodule = pmoduleModule.all.filter(x => x.guid == item.sender);
    if (!fmodule.length) return;
    const module = fmodule[0];
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(module.type),
      params: {id: `${module.id}`},
    });
    window.open(href, '_blank');
  }

  getModuleStore(type: PModuleType): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(type) as any) as PModuleStoreModule;
  }

  // Закрыть соединения веб сокета
  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  // Открыть вебсокет
  openWS() {
    this.socket = connectionPModuleBokerEvents(
      this.selectedPModuleIds,
      this.eventTypes.filter(x => this.selectedEventTypesIds.includes(x.id)).map(x => x.name),
    );
    this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
  }

  //Действия на веб сокете
  subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (strParse) {
      //режем данные в data
      if (strParse.data) {
        for (const key of Object.keys(strParse.data)) {
          const value = strParse.data[key];
          if (value.slice && value.concat && value.length > this.sliceDataArrayLength) {
            strParse.data[key] = JSON.stringify(
              value.slice(0, this.sliceDataArrayLength).concat('...'),
            );
          }
        }
      }

      const id = this.logs.length ? (this.logs[this.logs.length - 1] as any).id + 1 : 1;
      const log = {
        collapsed: true,
        id,
        sender: strParse.sender,
        eventType: strParse.type,
        data: strParse.data,
        timestamp: strParse.timestamp,
      };
      const logs = [...this.logs];
      logs.push(log);

      if (logs.length > this.selectedSize.value) {
        logs.splice(0, logs.length - this.selectedSize.value);
      }
      this.logs = logs;

      if (!this.freeze) {
        this.viewLogs = [...this.logs];
      }
    }
  }
}
